import { ETourId, type ITourConfig } from '../types';

/**
 * Tour shown when the user first enters the action item review page.
 *
 * Three steps:
 * 1. See what's impacted — the exception list sidebar
 * 2. Check the source — the AOP editor / document viewer
 * 3. Resolve with AI — the resolution agent chat panel
 */
export const guidanceCenterActionItemReviewTour: ITourConfig = {
  id: ETourId.GUIDANCE_CENTER_ACTION_ITEM_REVIEW,
  // In new flow, do not trigger this tour. Disabling it for now.
  enabled: false,
  steps: [
    {
      id: 'review-exception-list',
      target: '[data-tour-id="review-exception-list-panel"]',
      titleKey: 'tours.guidanceCenterActionItemReview.exceptionList.title',
      descriptionKey:
        'tours.guidanceCenterActionItemReview.exceptionList.description',
      position: 'rightTop',
    },
    {
      id: 'review-source-panel',
      target: '[data-tour-id="review-source-panel"]',
      titleKey: 'tours.guidanceCenterActionItemReview.sourcePanel.title',
      descriptionKey:
        'tours.guidanceCenterActionItemReview.sourcePanel.description',
      position: 'rightTop',
    },
    {
      id: 'review-resolution-panel',
      target: '[data-tour-id="review-resolution-panel"]',
      titleKey: 'tours.guidanceCenterActionItemReview.resolutionPanel.title',
      descriptionKey:
        'tours.guidanceCenterActionItemReview.resolutionPanel.description',
      finishLabelKey:
        'tours.guidanceCenterActionItemReview.resolutionPanel.finishLabel',
      position: 'leftTop',
    },
  ],
  namespace: 'tours',
  variant: 'default',
  size: 'sm',
  analytics: {
    enabled: true,
    eventPrefix: 'tour_guidance_center_action_item_review',
    metadata: {
      tourName: 'Guidance Center Action Item Review',
    },
  },
  persistence: {
    strategy: 'localStorage',
  },
};
